export default "__VITE_ASSET__9e746e41__"